<template>
  <v-col cols="12" md="2">
    <v-hover v-slot="{ hover }">
      <v-card
        class="card-resume rounded-lg"
        @click="formInvite(evento)"
        color="base"
        flat
      >
        <v-img
          :src="evento.imagens.destaque || evento.imagens.imagem1"
          class="white--text align-end rounded-lg"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,1.5)"
          height="130px"
        >
          <div v-if="evento.status == 'ATIVO'" class="clip-card">
            <span>ATIVO</span>
          </div>
          <div v-if="evento.status == 'INATIVO'" class="clip-card-inativo">
            <span>INATIVO</span>
          </div>
          <div v-if="evento.status == 'ESGOTADO'" class="clip-card-esgotado">
            <span>ESGOTADO</span>
          </div>
          <v-card-title class="font-weight-bold text-body-2 teste">
            {{ evento.descricao | cutText(36) }}
          </v-card-title>
        </v-img>
        <v-expand-transition>
          <v-overlay
            opacity="1"
            v-if="hover"
            class="overlay-add d-flex transition-fast-in-fast-out v-card--reveal white--text"
          >
            <div class="d-flex flex-column justify-center align-center">
              <v-btn color="primary" fab small class="mb-2">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <span class="font-weight-bold">
                {{ $t("marketing.invitation.create-invitation") }}
              </span>
            </div>
          </v-overlay>
        </v-expand-transition>
      </v-card>
    </v-hover>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "CardInvitation",
  props: {
    evento: {
      type: Object,
      required: true,
    },
  },
  title: {
    type: String,
    required: false,
    default: "",
  },
  methods: {
    ...mapActions(["fetchInviteEvent", "setSalesByTicketDash"]),
    formInvite(evento) {
      const event = evento?.idproduto;
      localStorage.setItem("eventoData", JSON.stringify(evento));
      this.$router.push(`convite/listar/${event}`);
    },
  },
};
</script>
<style>
.card-resume {
  position: relative;
  cursor: pointer;
  max-height: 200px;
  border-radius: 50px;
  box-shadow: 11px 11px 22px #d9d9d9, 11px 11px 22px #ffffff;
  transition: all 0.2s ease-in-out;
}

.card-resume:hover {
  transform: scale(1.05);
  box-shadow: 11px 11px 12px #d9d9d903, 11px 11px 22px #ffffff;
}

.overlay-add {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.clip-card {
  position: absolute;
  right: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}

.clip-card span {
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 100px;
  display: block;
  background: #03a709;
  background: linear-gradient(#00d100 0%, #03a709 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 19px;
  right: -21px;
}
.clip-card span::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid #03a709;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #03a709;
}
.clip-card span::after {
  content: "";
  position: absolute;
  right: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid #03a709;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #03a709;
}

.clip-card-inativo {
  position: absolute;
  right: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}

.clip-card-inativo span {
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 100px;
  display: block;
  background: #8f0808;
  background: linear-gradient(#f70505 0%, #8f0808 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 19px;
  right: -21px;
}
.clip-card-inativo span::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid #8f0808;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #8f0808;
}
.clip-card-inativo span::after {
  content: "";
  position: absolute;
  right: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid #8f0808;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #8f0808;
}
.clip-card-esgotado {
  position: absolute;
  right: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}

.clip-card-esgotado span {
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 100px;
  display: block;
  background: #1e5799;
  background: linear-gradient(#2989d8 0%, #1e5799 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 19px;
  right: -21px;
}
.clip-card-esgotado span::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid #1e5799;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #1e5799;
}
.clip-card-esgotado span::after {
  content: "";
  position: absolute;
  right: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid #1e5799;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #1e5799;
}
</style>
